// OTE (Overtime Exemption) — browser helpers. Every important OTE step goes through the ote-actions server function.
import { supabase } from './supabase'

// Call ote-actions; throws an Error carrying the server's plain-English message.
export async function oteAction(body) {
  const { data, error } = await supabase.functions.invoke('ote-actions', { body })
  if (error) {
    let msg = error.message
    try { const b = await error.context.json(); msg = b.error || msg; if (b.missing) msg += ':\n• ' + b.missing.join('\n• ') } catch (e) { /* keep message */ }
    throw new Error(msg)
  }
  if (data?.error) throw new Error(data.error)
  return data
}

// File → base64 (no "data:…," prefix), for sending a small picture to the server.
export const fileToBase64 = file => new Promise((resolve, reject) => {
  const r = new FileReader()
  r.onload = () => resolve(String(r.result).split(',')[1] || '')
  r.onerror = () => reject(new Error('The file could not be read.'))
  r.readAsDataURL(file)
})
